import { useQuery } from '@tanstack/react-query'
import api from '@/lib/axios'

/**
 * Reemplazo mínimo de useEspecialidadMedico.ts (eliminado — ver
 * .planning/specs/gating-ficha-paciente-por-perfil-clinica.md). La facultad de prescribir es
 * un requisito de licencia/cédula del médico, independiente de cualquier perfil de clínica o
 * de especialidad, así que sigue resolviéndose a nivel de médico individual.
 */
export function useFacultadPrescribir() {
  const { data, isLoading } = useQuery({
    queryKey: ['medicos', 'me'],
    queryFn: () => api.get('/api/medicos/me').then(r => r.data),
    staleTime: 5 * 60 * 1000,
  })

  const especialidades = (data?.especialidades ?? []) as { facultadPrescribir: boolean | null }[]
  const tieneFacultadPrescribir = especialidades.some(e => e.facultadPrescribir === true)

  return { tieneFacultadPrescribir, isLoading }
}
